import { useEffect, useState } from "react";
import { Crown, ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";

const FEATURES = [
  ["tax_compliance", "Tax compliance"],
  ["predictive_payroll", "Predictive payroll"],
  ["reports", "Advanced reporting"],
  ["ai_concierge", "AI concierge"],
  ["remote_monitoring", "Remote monitoring / geofencing"],
  ["client_billing", "Client billing"],
];

/** Sovereign Founder status — rendered only for the root admin. Proof, on
 *  screen, that the whole suite is held outright and never billed. */
export default function SovereignStatus({ user }) {
  const [tier, setTier] = useState(null);

  useEffect(() => {
    if (!user?.is_root_admin) return;
    api.get("/billing/tier").then(({ data }) => setTier(data)).catch(() => setTier(null));
  }, [user?.is_root_admin]);

  if (!user?.is_root_admin || !tier?.sovereign) return null;

  return (
    <div
      data-testid="sovereign-status-card"
      className="border-2 p-5 sm:p-6"
      style={{ borderColor: "#C9A356", background: "#030E2A", color: "#F6EEDA" }}
    >
      <div className="flex items-start gap-3">
        <div className="p-2 border-2 shrink-0" style={{ borderColor: "#C9A356" }}>
          <Crown className="w-4 h-4" style={{ color: "#C9A356" }} strokeWidth={2.5} />
        </div>
        <div className="min-w-0">
          <div
            data-testid="sovereign-status-label"
            className="font-mono text-[10px] uppercase tracking-widest"
            style={{ color: "#C9A356" }}
          >
            Sovereign Founder · Full suite held outright
          </div>
          <h2 className="font-heading font-black text-base md:text-lg mt-1">
            {tier.organization || user.organization || "Paradox Unlimited"}
          </h2>
          {tier.workspace && tier.workspace !== tier.organization && (
            <div data-testid="sovereign-workspace" className="font-mono text-[10px] uppercase tracking-widest mt-1"
                 style={{ color: "#C7BFA8" }}>
              Active workspace · {tier.workspace}
            </div>
          )}
          <p className="font-mono text-xs mt-2 leading-relaxed" style={{ color: "#C7BFA8" }}>
            Every module is unlocked in this workspace at{" "}
            <span data-testid="sovereign-price" className="font-black">$0/mo</span> — no
            subscription, no upgrade prompt, in any lane you open.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1.5 mt-4">
            {FEATURES.filter(([k]) => tier.features?.[k]).map(([k, label]) => (
              <div key={k} data-testid={`sovereign-feature-${k}`}
                   className="flex items-center gap-2 font-mono text-[11px]">
                <ShieldCheck className="w-3 h-3 shrink-0" style={{ color: "#C9A356" }} />
                <span>{label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
